import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { HomeHero } from "@/components/home/HomeHero";
import { HomePillars, HomeProcess, HomeFamily } from "@/components/home/HomeSections";
import { HomeSports, HomeFinalCta } from "@/components/home/HomeSportsCta";

// Testimonials ("Voices") section is hidden until real testimonials are available.
export default function Home() {
  const { t } = useI18n();
  return (
    <>
      <HomeHero t={t} />
      <HomePillars t={t} />
      <HomeProcess t={t} />
      <HomeSports t={t} />
      <HomeFamily t={t} />
      <HomeFinalCta t={t} />
    </>
  );
}
